var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.href,"target":"_blank","rel":"nofollow noopener"}},[_c('IconBase',{attrs:{"viewBox":"0 0 32 32"}},[_c('pdfIco')],1),_c('span',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }